/* PDP — Dirección A · Editorial (mockups: pdp-direccion-a.jsx + pdp-extras.jsx).
   Galería swipe con contain, selector de talla desplegable (agotadas visibles y
   deshabilitadas), guía de tallas en sheet por marca, fake-door WA, fecha estimada,
   CTA sticky conectado al carrito de ui.js. Reglas puras en pdp-reglas.js (PM-63). */
(function(){
  /* nota de fit por marca (lookup case-insensitive; se afina con vendedores) */
  var FIT = {
    "golden goose": "Golden Goose corre chico: pide media talla arriba.",
    "alexander mcqueen": "McQueen corre grande: considera media talla abajo."
  };
  var FIT_DEFAULT = "¿Dudas con tu talla? Escríbenos y te asesoramos como en tienda.";
  /* tablas de la guía (modal aprobado en pdp-extras.jsx) */
  var GUIA_TENIS = { head: ["MX","US","EU","CM"], rows: [
    ["24.5","6.5","39","24.5"],["25","7","40","25.0"],["25.5","7.5","40.5","25.5"],
    ["26","8","41","26.0"],["26.5","8.5","42","26.5"],["27","9","42.5","27.0"],
    ["27.5","9.5","43","27.5"],["28","10","43.5","28.0"],["29","11","44.5","29.0"]] };
  var GUIA_ROPA = { head: ["TALLA","PECHO","LARGO"], rows: [
    ["S","86-91 cm","68 cm"],["M","91-96 cm","71 cm"],
    ["L","96-101 cm","74 cm"],["XL","101-107 cm","77 cm"]] };

  var params = new URLSearchParams(location.search);
  var handle = window.PDP_HANDLE || params.get("handle") || params.get("p");
  var p; // se asigna en DOMContentLoaded, después del guard de CATALOG
  var sel = null;
  var lbIdx = 0; // índice de la foto abierta en el lightbox
  var entrega = null; // texto de la fecha estimada; se calcula una vez en init()

  function fitNote(){ return FIT[p.brand.toLowerCase()] || FIT_DEFAULT; }
  function esUnitalla(){ return p.variants.length === 1 && /unitalla/i.test(p.variants[0].size); }
  function ultimaPieza(){ return p.variants.filter(function(v){ return v.available; }).reduce(function(n,v){ return n+v.qty; },0) === 1; }
  function precioVar(){ return sel || p.variants.find(function(v){ return v.available; }) || p.variants[0]; }
  function precio(){ var v = precioVar(); return v ? v.price : 0; }
  function waLink(size){
    var t = size ? parseTalla(size) : null;
    var tallaTxt = t ? (t.label + (t.alt ? " (" + t.alt + ")" : "")) : "";
    var msg = "Hola, me interesa " + p.title + " de " + p.brand + (tallaTxt ? " en talla " + tallaTxt : "") + ", ¿me la pueden conseguir?";
    return UI.WA + "?text=" + encodeURIComponent(msg);
  }
  /* talla monótona: el chip muestra solo CM; la equivalencia (EU/US) aparece al
     seleccionar y las conversiones completas viven en la guía. Sin CM (ej. McQueen
     "44 EU"), el chip muestra lo que hay: convertir sin dato sería inventar. */
  function parseTalla(s){
    var m = s.match(/([\d.]+)\s*CM/i);
    if (!m) return { cm: null, alt: null, label: s };
    var alt = null;
    s.split("/").forEach(function(seg){
      if (!/CM/i.test(seg) && /\d/.test(seg)) alt = seg.trim();
    });
    return { cm: parseFloat(m[1]), alt: alt, label: m[1] + " CM" };
  }
  function labelTalla(){
    /* tenis con CM → "TALLA (CM)"; ropa (letras) y tallas solo-EU → "TALLA" a secas (review Kike 12/06) */
    return p.variants.some(function(v){ return parseTalla(v.size).cm !== null; }) ? "TALLA (CM)" : "TALLA";
  }

  function detalles(){
    var esc = function(t){ return String(t).replace(/&/g,"&amp;").replace(/</g,"&lt;"); };
    var cfg = window.PDP_CONFIG || {};
    return PDPReglas.textoDetalles(p, cfg.origenPorMarca).map(function(o){ return '<p>'+esc(o)+'</p>'; }).join("");
  }

  /* galería: swipe horizontal con scroll-snap + dots (solo fotos: la ficha
     técnica se movió al acordeón — cambio Kike 12/07). Con una sola foto no
     hay dots (nada que swipear). El frame es gris #F4F4F4 y el tratamiento del
     fondo de la foto lo decide bg.js (data-bg). */
  function galeria(){
    var imgs = p.images.length ? p.images : [null];
    var ph = function(u,i){
      return '<div class="gal-ph" data-bg="blanco">' + (u
        ? '<img '+(i?'loading="lazy" ':'')+'src="'+u+'" alt="'+p.title+' foto '+(i+1)+'">'
        : '<span class="ph-tag">FOTO PENDIENTE</span>') + '</div>';
    };
    var el = document.getElementById("galeria");
    var slides = imgs.map(function(u,i){ return '<div class="gal-slide">' + ph(u,i) + '</div>'; });
    el.innerHTML =
      '<div class="gal-track" id="galTrack">' + slides.join("") + '</div>' +
      (slides.length > 1
        ? '<div class="gal-dots" aria-hidden="true">' + slides.map(function(_,i){ return '<span'+(i===0?' class="on"':'')+'></span>'; }).join("") + '</div>'
        : '');
    var track = document.getElementById("galTrack");
    track.addEventListener("scroll", function(){
      var s = track.querySelector(".gal-slide");
      var paso = (s ? s.offsetWidth : track.clientWidth) + 8;
      var i = Math.round(track.scrollLeft / paso);
      document.querySelectorAll(".gal-dots span").forEach(function(d,j){ d.classList.toggle("on", j===i); });
    }, {passive:true});
  }

  /* lightbox: abre la foto a pantalla completa, con flechas, miniaturas y zoom al
     tocar (Kike 15/06 — "que puedan picarle a la foto y ver el producto completo").
     Las fotos vienen ya editadas (lienzo 1:1 estándar); se muestran tal cual, sin
     tratamiento de fondo/color. */
  function lbRender(){
    var box = document.getElementById("lightbox");
    if (!box) return;
    var imgs = p.images;
    var multi = imgs.length > 1;
    box.innerHTML =
      '<button class="lb-x" aria-label="Cerrar" onclick="PDP.zoomClose()">✕</button>' +
      (multi ? '<button class="lb-nav lb-prev" aria-label="Foto anterior" onclick="PDP.zoomGo(-1)">‹</button>' : '') +
      '<div class="lb-stage" id="lbStage" onclick="PDP.zoomToggle()">' +
        '<img id="lbImg" src="'+imgs[lbIdx]+'" alt="'+p.title+' foto '+(lbIdx+1)+'"></div>' +
      (multi ? '<button class="lb-nav lb-next" aria-label="Foto siguiente" onclick="PDP.zoomGo(1)">›</button>' : '') +
      (multi ? '<div class="lb-thumbs">' + imgs.map(function(u,i){
        return '<button class="lb-thumb'+(i===lbIdx?' on':'')+'" data-bg="blanco" aria-label="Foto '+(i+1)+'" onclick="PDP.zoomSet('+i+')"><img src="'+u+'" alt=""></button>';
      }).join("") + '</div>' : '');
  }

  /* zona 3 — talla: selector desplegable; Unitalla colapsa a una línea */
  function zonaTalla(){
    if (esUnitalla()) {
      return '<section class="pdp-zone"><div class="pdp-talla-unica">' +
        '<span class="pdp-label">TALLA — UNITALLA</span>' +
        '<span class="pdp-fit-inline">Ajustable, talla única.</span>' +
      '</div></section>';
    }
    /* sin nota de fit aquí (Kike 12/07): las notas de talla ("corre chico"…)
       viven SOLO en la guía de tallas (PDP.guia) */
    var opcion = function(v){ var t = parseTalla(v.size); return t.label + (t.alt ? " (" + t.alt + ")" : ""); };
    return '<section class="pdp-zone pdp-tallas">' +
      '<div class="pdp-tallas-head"><span class="pdp-label">'+labelTalla()+'</span>' +
        '<a class="pdp-guia-link" href="#" data-track="guia-tallas" onclick="PDP.guia();return false;">GUÍA DE TALLAS</a></div>' +
      '<select class="talla-select" id="tallaSelect" aria-label="Talla" onchange="PDP.elige(this.value)" onpointerdown="this.classList.add(\'por-puntero\')" onkeydown="this.classList.remove(\'por-puntero\')" onblur="this.classList.remove(\'por-puntero\')">' +
        '<option value=""'+(sel?'':' selected')+'>Elige tu talla</option>' +
        p.variants.map(function(v,i){
          return '<option value="'+i+'"'+(v.available?'':' disabled')+(sel===v?' selected':'')+'>'+opcion(v)+(v.available?'':' — agotada')+'</option>';
        }).join("") + '</select>' +
      '<div class="pdp-fakedoor"><em>¿No está tu talla? Te la conseguimos —</em> ' +
        '<a data-track="fake-door-talla" data-track-size="'+(sel?sel.size:"")+'" href="'+waLink(sel?sel.size:"")+'" target="_blank" rel="noopener">WhatsApp →</a></div>' +
    '</section>';
  }

  function col(){
    var colEl = document.getElementById("pdpCol");
    // snapshot: acordeones abiertos, para restaurar tras el re-render por selección
    var prev = colEl.querySelectorAll("details");
    var openIdx = []; prev.forEach(function(d,i){ if(d.open) openIdx.push(i); });
    /* primer render: TODO cerrado, también en desktop (cambio Kike 12/07).
       Re-renders conservan el estado. */
    var ctaTxt = 'AGREGAR A LA BOLSA';
    /* precio con tachado solo en oferta REAL (compareAt>price); fuera de oferta, idéntico */
    var pv = precioVar();
    var precioMarkup = (pv && pv.compareAt && pv.compareAt > pv.price)
      ? money(pv.price) + ' <span>MXN</span> <span class="pdp-antes">' + money(pv.compareAt) + '</span>'
      : money(precio()) + ' <span>MXN</span>';
    /* cita textual de garantia.html — una sola versión de la política en todo el sitio */
    var citaGarantia = 'Autenticidad garantizada. Si dudas que es original, te devolvemos tu dinero.';
    var citaEnvios = 'Gratis y rastreable, a todo México.';
    var citaCambios = '¿No te quedó? Cámbiala — aplica en todos nuestros productos.';
    colEl.innerHTML =
      /* zona 1 — identidad */
      '<section class="pdp-zone">' +
        '<div class="pdp-id-row"><a class="pdp-marca eyebrow" href="'+COLL+'?marca='+encodeURIComponent(p.brand).replace(/%20/g, "+")+'">'+p.brand.toUpperCase()+'</a>' +
        (ultimaPieza() ? '<span class="pdp-tag">ÚLTIMA PIEZA</span>' : '') + '</div>' +
        '<h1 class="pdp-title">'+p.title+'</h1>' +
        '<p class="pdp-precio">'+precioMarkup+'</p>' +
      '</section>' +
      /* (la zona 2 —promesa landed-cost— se quitó de la PDP también en desktop,
         Kike 12/07: el mensaje vive en la cinta del hero del home, que en
         desktop es grid estático con "Precio final. Ya en México" como item 1) */
      /* zona 3 — talla */
      zonaTalla() +
      /* CTA en flujo (desktop); en móvil vive en #ctaSticky */
      '<button class="pdp-cta" data-track="add-to-cart" onclick="PDP.add()">'+ctaTxt+'</button>' +
      (entrega ? '<p class="pdp-entrega">'+entrega+'</p>' : '') +
      /* acordeones (PM-63): DETALLES en texto corrido reemplaza a FICHA TÉCNICA; sin
         palomitas de beneficios ni protocolo de verificación */
      '<section class="pdp-zone pdp-acordeones">' +
        (window.PDPReglas ? '<details><summary>DETALLES</summary>' + detalles() + '</details>' : '') +
        '<details><summary>GARANTÍA DE AUTENTICIDAD</summary><p>'+citaGarantia+' <a href="/pages/garantia">Ver la política completa</a>.</p></details>' +
        '<details><summary>ENVÍOS Y CAMBIOS</summary><p>'+citaEnvios+' '+citaCambios+' <a href="/pages/garantia">Ver la política completa</a>.</p></details>' +
      '</section>';
    colEl.querySelectorAll("details").forEach(function(d,i){ if(openIdx.indexOf(i)!==-1) d.open = true; });
    document.getElementById("ctaSticky").innerHTML =
      '<button class="btn btn-ink" data-track="add-to-cart" onclick="PDP.add()">'+ctaTxt+'</button>';
    document.getElementById("bread").innerHTML =
      '<a href="/">COMMONS</a> / <a href="'+COLL+'?c='+p.category+'">'+p.category.toUpperCase()+'</a> / '+p.brand.toUpperCase();
  }

  window.PDP = {
    /* sin re-render de la columna: rehacerla destruiría el select y su foco (spec R1) */
    elige: function(i){
      sel = i === "" ? null : p.variants[+i];
      var pv = precioVar();
      var pr = document.querySelector(".pdp-precio");
      if (pr) pr.innerHTML = (pv && pv.compareAt && pv.compareAt > pv.price)
        ? money(pv.price) + ' <span>MXN</span> <span class="pdp-antes">' + money(pv.compareAt) + '</span>'
        : money(precio()) + ' <span>MXN</span>';
      var wa = document.querySelector(".pdp-fakedoor a");
      if (wa) { wa.href = waLink(sel ? sel.size : ""); wa.setAttribute("data-track-size", sel ? sel.size : ""); }
    },
    add: function(){
      if (!sel || !sel.available) {
        var t = document.querySelector(".pdp-tallas") || document.querySelector(".pdp-talla-unica");
        if (t) { t.scrollIntoView({block:"center", behavior:"smooth"}); t.classList.add("shake"); setTimeout(function(){ t.classList.remove("shake"); },500); }
        return;
      }
      /* medición: add_to_cart con la talla elegida (H2.2 tallas, embudo) */
      if (window.Track) Track.emit("add_to_cart", { item_id: p.handle, item_name: p.title, item_brand: p.brand, item_category: p.category, item_variant: sel.size, price: sel.price, value: sel.price, currency: "MXN" });
      Cart.add(sel.id);
    },
    guia: function(){
      var g = p.category === "tenis" ? GUIA_TENIS : GUIA_ROPA;
      var n = g.head.length;
      var fila = function(cells, head){
        return '<div class="guia-tr guia-tr--'+n+(head?' guia-tr--head':'')+'">' +
          cells.map(function(c){ return '<span>'+c+'</span>'; }).join("") + '</div>';
      };
      document.getElementById("modalGuia").innerHTML =
        '<div class="modal-head"><span>GUÍA DE TALLAS</span><button aria-label="Cerrar" onclick="PDP.cerrarGuia()">✕</button></div>' +
        '<p class="pdp-marca eyebrow">'+p.brand.toUpperCase()+'</p>' +
        '<p class="pdp-fit">'+fitNote()+'</p>' +
        '<div class="guia-tabla">' + fila(g.head, true) + g.rows.map(function(r){ return fila(r); }).join("") + '</div>' +
        '<p class="guia-caption">Medidas del fabricante</p>' +
        '<p class="pdp-fit guia-dudas">¿Sigues con dudas? <a href="'+waLink("")+'" target="_blank" rel="noopener">Escríbenos por WhatsApp</a> y te asesoramos como en tienda.</p>';
      document.getElementById("modalGuia").classList.add("open");
      document.getElementById("modalVeil").classList.add("open");
      var cerrar = document.querySelector("#modalGuia .modal-head button"); if (cerrar) cerrar.focus();
    },
    cerrarGuia: function(){
      document.getElementById("modalGuia").classList.remove("open");
      document.getElementById("modalVeil").classList.remove("open");
      var back = document.querySelector('[data-track="guia-tallas"]'); if (back) back.focus();
    },
    zoomOpen: function(i){
      if (!p.images.length) return;
      lbIdx = i || 0; lbRender();
      var box = document.getElementById("lightbox");
      box.classList.add("open"); box.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      var x = box.querySelector(".lb-x"); if (x) x.focus();
    },
    zoomSet: function(i){ lbIdx = i; lbRender(); },
    zoomGo: function(d){ var n = p.images.length; if (!n) return; lbIdx = (lbIdx + d + n) % n; lbRender(); },
    zoomToggle: function(){ var s = document.getElementById("lbStage"); if (s) s.classList.toggle("is-zoom"); },
    zoomClose: function(){
      var box = document.getElementById("lightbox"); if (!box) return;
      box.classList.remove("open"); box.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
  };

  function start(){
    p = window.PDP_PRODUCT || (window.CATALOG && window.CATALOG.ready ? UI.product(handle) : null);
    if (!p) { window.onCatalog(function(){ p = UI.product(handle) || window.CATALOG.products[0]; init(); }); return; }
    init();
  }
  function init(){
    /* chips en orden de talla (Shopify no garantiza orden): CM ascendente; letras
       en secuencia XS<S<M<L<XL (no alfabético — "S" < "XS" daría S antes que XS) */
    var SIZE_ORDER = { XS:1, S:2, M:3, L:4, XL:5, XXL:6, XXXL:7, Unitalla:99 };
    p.variants.sort(function(a,b){
      var ca = parseTalla(a.size).cm, cb = parseTalla(b.size).cm;
      if (ca !== null && cb !== null) return ca - cb;
      if (ca !== null) return -1;
      if (cb !== null) return 1;
      var oa = SIZE_ORDER[String(a.size).toUpperCase()], ob = SIZE_ORDER[String(b.size).toUpperCase()];
      if (oa && ob) return oa - ob;
      if (oa) return -1;
      if (ob) return 1;
      return String(a.size).localeCompare(String(b.size), "es", {numeric:true});
    });
    if (esUnitalla()) sel = p.variants[0]; // Unitalla: no hay talla que elegir
    try {
      var envio = (window.THEME && THEME.envio) || {};
      var fe = PDPReglas.fechaEntrega(Date.now(), envio.min, envio.max, envio.zona);
      entrega = fe && fe.texto;
    } catch (e) { entrega = null; }
    // el título del catálogo suele incluir la marca; no duplicarla
    document.title = (p.title.toUpperCase().indexOf(p.brand.toUpperCase()) !== -1 ? p.title : p.brand + " " + p.title) + " — COMMONS®";
    galeria(); col();
    /* medición: vista de producto (embudo — precede a add_to_cart/checkout) */
    if (window.Track) Track.emit("view_item", { item_id: p.handle, item_name: p.title, item_brand: p.brand, item_category: p.category, price: precio(), currency: "MXN" });
    document.getElementById("modalVeil").addEventListener("click", window.PDP.cerrarGuia);
    /* tocar cualquier foto de la galería abre el lightbox en esa foto */
    document.getElementById("galeria").addEventListener("click", function(e){
      var ph = e.target.closest(".gal-ph");
      if (!ph || !p.images.length) return;
      var slides = Array.prototype.slice.call(document.querySelectorAll("#galeria .gal-ph"));
      var i = slides.indexOf(ph);
      window.PDP.zoomOpen(i < 0 ? 0 : i);
    });
    /* teclado del lightbox: Esc cierra, flechas navegan */
    document.addEventListener("keydown", function(e){
      var box = document.getElementById("lightbox");
      if (!box || !box.classList.contains("open")) return;
      if (e.key === "Escape") window.PDP.zoomClose();
      else if (e.key === "ArrowLeft") window.PDP.zoomGo(-1);
      else if (e.key === "ArrowRight") window.PDP.zoomGo(1);
    });

    document.addEventListener("keydown", function(e){ if(e.key==="Escape") window.PDP.cerrarGuia(); });
    /* Completa el look (PM-63, pdp-reglas.js) y Recomendaciones: misma marca primero,
       rellena con misma categoría; excluye el producto actual, productos sin foto y lo
       que ya salió en Completa el look. Cada fila se muestra solo si tiene productos. */
    window.onCatalog(function(C){
      var cfg = window.PDP_CONFIG || {};
      var limpia = function(l){ return (l || []).map(function(t){ return String(t).trim(); }).filter(Boolean); };
      var grupos = { tops: limpia(cfg.grupos && cfg.grupos.tops), bottoms: limpia(cfg.grupos && cfg.grupos.bottoms) };
      var visto = UI.product(p.handle) || p; // categoría del catálogo, la misma regla que los candidatos (spec R3)
      var look = window.PDPReglas ? PDPReglas.completaLook(visto, C.products, cfg.masVendidos || [], grupos) : [];
      var enLook = {}; look.forEach(function(x){ enLook[x.handle] = true; });
      var pool = C.products.filter(function(x){ return x.handle !== p.handle && x.images.length && !enLook[x.handle]; });
      var rel = pool.filter(function(x){ return x.brand === p.brand; })
        .concat(pool.filter(function(x){ return x.brand !== p.brand && x.category === visto.category; }));
      var pinta = function(lista, idGrid, idSec){
        if (!lista.length) return;
        document.getElementById(idGrid).innerHTML = lista.map(UI.card.bind(UI)).join("");
        document.getElementById(idSec).hidden = false;
      };
      pinta(look, "look", "lookSec");
      pinta(rel.slice(0,4), "related", "relatedSec");
    });
  }
  document.addEventListener("DOMContentLoaded", start);
})();
